/* bs-encuentra — modal de ayuda "¿Cómo aplicarlo?" (banner IVA 4%).
   Custom element que envuelve un <button> trigger + un <dialog> nativo.
   El <dialog> aporta backdrop, cierre con ESC y foco atrapado sin librerías. */
class BSIvaHelp extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('[data-bs-iva-trigger]');
    this.dialog = this.querySelector('[data-bs-iva-dialog]');
    if (!this.trigger || !this.dialog) return;

    this.trigger.addEventListener('click', () => {
      if (typeof this.dialog.showModal === 'function') {
        this.dialog.showModal();
      } else {
        // Fallback navegadores sin <dialog>: mostrar como bloque.
        this.dialog.setAttribute('open', '');
      }
    });

    this.querySelectorAll('[data-bs-iva-close]').forEach((btn) => {
      btn.addEventListener('click', () => this.dialog.close());
    });

    // Cerrar al pulsar el backdrop (click cuyo target es el propio <dialog>).
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });
  }
}

if (!customElements.get('bs-iva-help')) {
  customElements.define('bs-iva-help', BSIvaHelp);
}
